import { documentPackageSchema, getPackagesResponseSchema, createPackageResponseSchema, } from '@consigli/types';
import { createTransformer, mapToSnakeCase } from './shared/base-api';
export const documentPackageApiEndpoints = (builder, coreApiBaseUrl) => ({
    getPackage: builder.query({
        query: ({ projectId, packageId }) => `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/`,
        transformResponse: createTransformer(documentPackageSchema, 'GetPackage'),
        providesTags: (result, error, { packageId }) => [
            { type: 'DocumentPackages', id: packageId },
            'DocumentPackages',
        ],
    }),
    getPackages: builder.query({
        query: ({ projectId }) => `${coreApiBaseUrl}/projects/${projectId}/packages/`,
        transformResponse: createTransformer(getPackagesResponseSchema, 'GetPackages'),
        providesTags: ['DocumentPackages'],
    }),
    getPackagesByType: builder.query({
        query: ({ projectId, type }) => `${coreApiBaseUrl}/projects/${projectId}/packages/?type=${type}`,
        transformResponse: createTransformer(getPackagesResponseSchema, 'GetPackagesByType'),
        providesTags: ['DocumentPackages'],
    }),
    createPackage: builder.mutation({
        query: ({ projectId, type, name, language, needClassification, selectedConflictTypes, employerRole, data, }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/`,
            method: 'POST',
            body: mapToSnakeCase({
                name,
                project: projectId,
                type,
                language,
                needClassification,
                selectedConflictTypes,
                employerRole,
                data,
            }),
        }),
        transformResponse: createTransformer(createPackageResponseSchema, 'CreatePackage'),
        invalidatesTags: ['DocumentPackages', 'Projects'],
    }),
    updatePackage: builder.mutation({
        query: ({ projectId, packageId, data }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/`,
            method: 'PATCH',
            body: mapToSnakeCase(data),
        }),
        invalidatesTags: (result, error, { packageId }) => [
            { type: 'DocumentPackages', id: packageId },
            'DocumentPackages',
        ],
        transformResponse: createTransformer(documentPackageSchema, 'UpdateDocumentPackage'),
    }),
    deletePackage: builder.mutation({
        query: ({ projectId, packageId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['DocumentPackages', 'Blobs', 'Findings'],
    }),
    getDocumentPackageResults: builder.query({
        query: ({ projectId, packageId, page = 'all' }) => `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/results/?page=${page}`,
        providesTags: ['DocumentPackageResults'],
    }),
});
